import React, { useState, useRef } from "react";
import uploadImg from '../../assets/upload.png';

const ImageUpload = ({ setData, images, setImages }) => {
  // console.log(image)
  const refFile = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const maxSize = 5 * 1024 * 1024;

    if (file && file.size > maxSize) {
      alert("The file is too large. Please upload a file smaller than 5 MB.");
      return;
    }

    if (file) {
      const newImage = {
        name: file.name,
        url: URL.createObjectURL(file),
      };

      setImages([newImage]); // Update local state with a single image
      setData([file]); // Pass the single file to the parent
    }
  };
  const removeImage = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index)); // Remove from local state
    setData((prev) => prev.filter((_, i) => i !== index)); // Remove from parent state
  };
  return (
    <div className="relative w-full max-w-xs h-52 border-2 border-dashed border-blue-400 rounded-xl bg-white flex items-center justify-center shadow hover:shadow-md transition duration-300">
    {images.length === 0 ? (
      <div className="flex flex-col items-center text-center px-4">
        <img
          src={uploadImg}
          alt="Upload"
          className="w-16 h-16 mb-2 opacity-70"
        />
        <p className="text-sm text-blue-500 font-semibold">Drag & drop your image</p>
        <p className="text-xs text-gray-400 mt-1">or click to upload</p>
        <input
          name="image"
          ref={refFile}
          accept="image/*"
          type="file"
          onChange={handleFileChange}
          className="absolute inset-0 opacity-0 cursor-pointer"
        />
      </div>
    ) : (
      <div className="flex items-center space-x-4 px-4">
        {
        //  images.length > 0 ?
        images?.map((image, index) => (
          <div
            key={index}
            className="relative w-24 h-24 rounded-xl overflow-hidden shadow-lg border border-gray-200"
          >
            <img
              src={image.url}
              alt={`Uploaded ${index}`}
              className="w-full h-full object-cover"
            />
          </div>
        ))
      //   :
      //   <div
      //   className="relative w-24 h-24 rounded-xl overflow-hidden shadow-lg border border-gray-200"
      // >
      //   <img
      //     src={images}
      //     alt={`Uploaded Image`}
      //     className="w-full h-full object-cover"
      //   />
      // </div>
      }
  
        <div className="flex flex-col items-center justify-center space-y-1">
          <button
            onClick={() => refFile.current.click()}
            className="w-9 h-9 text-xl text-white bg-blue-500 rounded-full hover:bg-blue-600 shadow flex items-center justify-center"
          >
            +
          </button>
          <p className="text-xs text-gray-400">Change</p>
          <input
            name="image"
            ref={refFile}
            accept="image/*"
            type="file"
            onChange={handleFileChange}
            className="absolute inset-0 opacity-0 cursor-pointer"
          />
        </div>
      </div>
    )}
  </div>
  
  );
};

export default ImageUpload;
